// extracted by mini-css-extract-plugin
export var fadeIn = "_ms-1";
export var modalContent = "_ms-3";
export var overlay = "_ms-0";
export var popoverContent = "_ms-2";
export var results = "_ms-5";
export var searchInputWrapper = "_ms-4";